import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA support.
// 2026-06-10: rejestracja TYLKO w produkcyjnym buildzie. W dev (yarn start) SW
// cache-first walczyl z HMR/hashami webpacka => pETLA przeladowan. Na produkcji
// NODE_ENV="production" => SW dziala jak dotad (PWA bez zmian).
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then(() => {})
      .catch(() => {});
  });
}
